import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Dropdown, Tab, Modal } from "react-bootstrap";
import {
  get_CategoryRedirect,
  get_Notification_Condition,
  get_Single_Notification_rule,
} from "../../../store/actions/CommanAction";
import { useDispatch, useSelector } from "react-redux";
import { AddUpdate } from "../../../ApiMethods/ApiMethods";
import swal from "sweetalert";
import DataTable from "react-data-table-component";
import { customStyles } from "../Utility/Utility";
import { IoNotifications } from "react-icons/io5";
import { RxCross2 } from "react-icons/rx";
import Loader from "../Loader/Loader";

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { format } from "date-fns";

const NotificationRule = () => {
  const dispatch = useDispatch();
  const Notificationdata = useSelector(
    (state) => state.feedBackReducer.GetNotificationrule
  );
  const NotificatinConditiondata = useSelector(
    (state) => state.feedBackReducer?.CategoryConditionData ?? []
  );
  
  const CategoryNotificationData = useSelector(
    (state) => state.feedBackReducer?.CategoryRedirectData ?? []
  );

  const filterdata = CategoryNotificationData?.map((item) => item.Name);

  const SingleNotificationdata = useSelector(
    (state) => state.feedBackReducer.GetSingleNotificationRule
  );
  const customerID = Number(sessionStorage.getItem("ID"));
  const [editValue, setEditValue] = useState([]);
  const [postModel, setPostModel] = useState(false);
  const [editModel, setEditModel] = useState(false);
  const [id, setId] = useState("");

  const [ArrObj, setArrayObj] = useState([]);
  const [label, setLabel] = useState();
  const [querryText, setQuerryText] = useState("");
  const [autoManual, setautoManual] = useState(false);
  const [name, setname] = useState("");
  const [loading, setLoading] = useState(false);
  const [rulename, setRulename] = useState("");

  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [type, setType] = useState("push");
  const [audience, setAudience] = useState("All");
  const [scheduled, setScheduled] = useState(null);
  const [date, setDate] = useState("");
  const [fieldOptions, setFieldOptions] = useState([]);
  const [notificationId, setNotificationId] = useState("");
  const [file, setFile] = useState(" ");
  const [file1, setFile1] = useState(" ");

  const [beforeSendDays, setBeforeSendDays] = useState(false);
  const [columnType, setColumnType] = useState("");
  const [notificatinredirectvalue, setNotificationredctvalue] = useState("");
  const [data, setdata] = useState([]);
  const [customnotification, setCustomnotification] = useState("");

  const [filters, setFilters] = useState([
    { field: "zodiac", operator: "=", value: "", logic: "", columnType: "" },
  ]);

  const reset = () => {
    setTitle("");
    setMessage("");
    setType("");
    setAudience(" ");
    setScheduled();
    setBeforeSendDays(false);
    setColumnType("");
    setFilters([]);
    setCustomnotification("");
  };
  const handleFilterChange = (index, key, value) => {
    const updated = [...filters];
    updated[index][key] = value;
    setFilters(updated);
  };

  const addFilter = () => {
    setFilters([
      ...filters,
      {
        field: "",
        operator: "=",
        value: "",
        logic: "",
        columnType: filters.logic,
      },
    ]);
  };

  const deleteFilter = (index) => {
    const updated = filters.filter((_, i) => i !== index);
    setFilters(updated);
  };

  const handleSubmit = async () => {
    if (!title.trim()) {
      swal("Missing Title", "Please enter Notification Name.", "warning");
      return;
    }

    if (!audience) {
      swal("Missing Audience", "Please select an audience type.", "warning");
      return;
    }

    try {
      const isSegmentSelected = filters.length > 0;
      const isCustomMessageFilled = customnotification.trim() !== "";

      const formData = {
        NotificationName: title,
        NumberOfSendingDays: beforeSendDays ? message : 0,
        Audience: audience,
        BeforeSendDays: beforeSendDays,
        CustomQuery: customnotification,

        SegmentJson: isSegmentSelected
          ? JSON.stringify(
              filters?.map((filter, index) => {
                const base = {
                  ColumnType: String(filter.columnType || ""),
                  FieldName: String(filter.field || ""),
                  FieldValue: String(filter.value || ""),
                  Operator: String(filter.operator || ""),
                };

               
                if (filters.length > 1) {
                  base.LogicType = String(filter.logic || "AND");
                }

                return base;
              })
            )
          : "",

        NotificationRedirect: notificatinredirectvalue,
      };

     

      await AddUpdate(
        "NotificationSegments/Insert_NotificationSegments",
        formData
      );

      swal("Good job!", "Successfully inserted", "success");
      setPostModel(false);
    } catch (err) {
      console.error("Error submitting notification:", err);
      swal(
        "Error",
        "Something went wrong while submitting the notification.",
        "error"
      );
    }
  };
  const onchanges = (e) => {
    setNotificationredctvalue(e.target.value);
  };

  const dropdown = async () => {
    try {
      const postData = { Audience: audience };
      const response = await AddUpdate(
        "NotificationSegments/GetFieldDropDown",
        postData
      );

      const rawData = response?.data?.data || "{}";
      const parsedData = JSON.parse(rawData);

      if (Array.isArray(parsedData?.Table)) {
        setFieldOptions(parsedData.Table);
      } else {
        setFieldOptions([]);
        console.warn("Expected Table array, got:", parsedData);
      }
    } catch (err) {
      console.error("Dropdown API failed:", err);
      setFieldOptions([]);
    }
  };

  const getdatas = async () => {
    try {
      const postData = { IsActive: 1 };
      const response = await AddUpdate(
        "NotificationCondition/GetData_NotificationCondition",
        postData
      );
      const rawData = response?.data?.data || "{}";
      const parsedData = JSON.parse(rawData);

      if (Array.isArray(parsedData?.Table)) {
        setdata(parsedData?.Table);
      } else {
        setdata([]);
        console.warn("Expected Table array, got:", parsedData);
      }
    } catch (err) {
      console.error("Dropdown API failed:", err);
      setdata([]);
    }
  };
  

  useEffect(() => {
    if (audience === "User" || audience === "Astrologer") {
      dropdown();
    }
  }, [audience]);

  useEffect(() => {}, []);
  useEffect(() => {
    if (SingleNotificationdata?.length > 0) {
      setEditValue(SingleNotificationdata);
    }
  }, [SingleNotificationdata]);

  useEffect(() => {
    if (editValue && editValue.length > 0) {
      setRulename(editValue[0]?.NotificationName);
      setQuerryText(editValue[0]?.NotificationRule || "");
    }
  }, [editValue]);

  useEffect(() => {
    dispatch(get_CategoryRedirect("1"));
  }, []);

  const AddObj = () => {
    const newObj = {
      label: label,
      name: label,
      type: type,
      field: label,
      operator: "equal",
      value: "",
    };
    setArrayObj([...ArrObj, newObj]);
  };

  const HandleDrp = (e) => {
    const val = e.target.value;

    if (e) {
    
      if (val === "ID") {
        setLabel(val);
        setType("Number");
      } else if (val === "Name") {
        setLabel(val);
        setType("String");
      } else if (val === "Title") {
        setLabel(val);
        setType("String");
      } else if (val === "Location") {
        setLabel(val);
        setType("String");
      }
    } else {
      console.log("Error");
    }
  };

  const handleRowChange = (e, row, index) => {
    const newObj = {
      label: e.target.value,
      name: e.target.value,
      field: e.target.value,
      type: e.target.value === "ID" ? "Number" : "String",
      operator: row?.operator,
      value: row?.value,
    };

    const modifiedArr = ArrObj?.map((item, i) => (i === index ? newObj : item));

    setArrayObj(modifiedArr);
  };

  const handle_OperatorChange = (e, row, index) => {
    const newObj = {
      label: row?.label,
      name: row?.name,
      field: row?.field,
      type: row?.type,
      operator: e.target.value,
      value: row?.value,
    };

    const modifiedArr = ArrObj?.map((item, i) => (i === index ? newObj : item));
    setArrayObj(modifiedArr);
  };

  const handleChange = (e, row, index) => {
    const newObj = {
      label: row?.label,
      name: row?.name,
      field: row?.field,
      type: row?.type,
      operator: row?.operator,
      value: e.target.value,
    };

    const modifiedArr = ArrObj?.map((item, i) => (i === index ? newObj : item));
    setArrayObj(modifiedArr);
  };

  const SubmitQuerry = async (ModifiedArr) => {
    let queryTxt = "";

    ModifiedArr.forEach((item, index) => {
      const condition = `${item.field} ${getQueryValues(
        item.name,
        item.operator,
        item.value
      )}`;
      queryTxt += index === 0 ? condition : ` AND ${condition}`;
    });

    setQuerryText(queryTxt);
  };

  const handleFinalSubmit = async () => {
    if ((querryText && name) || autoManual) {
      const postdata = {
        NotificationName: rulename,
        NotificationRules: querryText,
      };

      try {
        const response = await AddUpdate(
          "NotificationRule/Insert_NotificationRule",
          postdata
        );

        dispatch(get_Notification_Condition(setLoading));
        swal("Good job!", "Successfully Inserted", "success");
        setPostModel(false);
      } catch (err) {
        console.error("Error saving notification:", err);
      }
    }
  };

  useEffect(() => {
    if (!autoManual && ArrObj.length > 0) {
      const labelValue = ArrObj[0]?.value || "";

      SubmitQuerry(ArrObj);
      setname(labelValue);
    }
  }, [ArrObj]);
  useEffect(() => {
    getdatas();
  }, []);

  const getQueryValues = (name, ope, val) => {
    if (ope === "Equal") {
      return `= ${val}`;
    } else if (ope === "Not Equal") {
      return `<> '${val}'`;
    } else if (ope === "Start With") {
      return `like '${val} %'`;
    } else if (ope === "Ends With") {
      return `like '%${val}'`;
    } else if (ope === "Contain") {
      return `like '%${val}%' `;
    } else if (ope === "In") {
      return `in ('${val}') `;
    } else if (ope === "Is Null") {
      return `${name}is Null`;
    } else if (ope === "Between") {
      return `${name} between ${"100"} and ${val}`;
    }
  };

  const handleDeleteRow = (index) => {
    setArrayObj((prevArr) => prevArr.filter((_, i) => i !== index));
  };

  const handleAddRow = () => {
    setArrayObj((prevArr) => {
      const newArr = [...prevArr];

      while (newArr.length < 5) {
        newArr.push({
          name: `field_${newArr.length}`,
          label: `Field ${newArr.length + 1}`,
          type: "text",
          value: "",
          operator: "",
        });
      }

      return newArr;
    });
  };

  const handleAddAstrologerClick = (row) => {
    reset();
    setPostModel(true);
  };
  const handleEditClick = async (row) => {
    Reset();
    setId(row.Id);
    setEditValue(row);
    dispatch(get_Single_Notification_rule(row.Id, setLoading));
    setEditModel(true);
  };
  const UpdeteClick = async () => {
    let updatedata = {
      NotificationRules: querryText,
      NotificationName: rulename,
      Id: id,
    };
    if (querryText) {
      await AddUpdate("NotificationRule/Update_NotificationRule", updatedata);
      dispatch(get_Notification_Condition(setLoading));
      swal("Good job!", "Successfully Inserted", "success");
      setEditModel(false);
    }
  };
  const handleToggleStatusClick = async (row) => {
   
    let deletedata = {
      ID: row,
      IsActive: 0,
    };
    await AddUpdate(
      "NotificationCondition/Delete_NotificationCondition",
      deletedata
    );
    dispatch(get_Notification_Condition(setLoading));
    swal("Good job!", "Successfully Deleted", "success");
  };
  const Reset = () => {
    setQuerryText("");
    setname("");
    setRulename("");
    setArrayObj([]);
  };
  const handleDateChange = (e) => {
    let value = e.target.value;

   
    if (value.length === 16) {
      value += ":00"; 
    }

    setDate(value);
  };

  const columns = [
    {
      name: "Notification Name",
      selector: (row) => row.NotificationName,
      sortable: true,
    },
    {
      name: "Audience",
      selector: (row) => row.Audience,
      sortable: true,
    },
  {
  name: "Date",
  selector: (row) => {
    if (row.CreatedDateTm === "1900-01-01T00:00:00" || !row.CreatedDateTm) {
      return "null";
    }

    const date = new Date(row.CreatedDateTm);


    const localDate = new Date(date.toLocaleString("en-US", { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone }));

    const day = localDate.getDate().toString().padStart(2, "0");
    const month = (localDate.getMonth() + 1).toString().padStart(2, "0");
    const year = localDate.getFullYear();

    let hours = localDate.getHours();
    const minutes = localDate.getMinutes().toString().padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12; 

    const formattedDate = `${day}-${month}-${year} ${hours}:${minutes} ${ampm}`;
    return formattedDate;
  },
  sortable: true,
}
,
    {
      name: (
        <p
          className="text-end"
          style={{ position: "absolute", top: "7px", right: 50 }}
        >
          Action
        </p>
      ),
      cell: (row) => (
        <>
          <div style={{ position: "absolute", top: 4, right: 50 }}>
            <Dropdown>
              <Dropdown.Toggle variant="" as="div" className="btn-link i-false">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 6C12.5523 6 13 5.55228 13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                  <path
                    d="M12 20C12.5523 20 13 19.5523 13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20Z"
                    stroke="#342E59"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </Dropdown.Toggle>
              <Dropdown.Menu alignRight={true} className="dropdown-menu-right">
               
                <Dropdown.Item
                  className="text-danger"
                  onClick={() => {
                    handleToggleStatusClick(row.ID, true, "0");
                  }}
                >
                  Delete
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </>
      ),
    },
  ];

  return (
    <div>
      <h2 style={{ color: "#f7931e", fontWeight: 700 }}>Notification Rules</h2>
      <Tab.Container defaultActiveKey="All">
        <div className="mt-4 d-flex justify-content-between align-items-center flex-wrap main_card">
          <div className="card-action coin-tabs mb-2"></div>
          <Link
            onClick={() => handleAddAstrologerClick(null)}
            className="btn btn-primary font-w600 mb-2 "
          >
            <span style={{ fontSize: "20px" }}>
              <IoNotifications />
            </span>{" "}
            Add Notification Rule
          </Link>
        </div>
        <div className="row mt-4 main_card">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body p-0">
                <Tab.Content>
                  <Tab.Pane eventKey="All">
                    {loading ? (
                      <Loader />
                    ) : (
                      <div className="table-responsive">
                        <DataTable
                          dense
                          data={data}
                          columns={columns}
                          selectableRowsHighlight
                          highlightOnHover
                          pagination
                          persistTableHead={true}
                          noDataComponent={"There are no data to display"}
                          customStyles={customStyles}
                        />
                      </div>
                    )}
                  </Tab.Pane>
                </Tab.Content>
              </div>
            </div>
          </div>
        </div>
      </Tab.Container>

      <div>
        <Modal
          className="modal fade "
          size="xl"
          // fullscreen

          show={postModel}
          onHide={() => setPostModel(false)}
          backdrop="static"
        >
          <div>
            <div
              className=" shadow"
              style={{ borderRadius: "12px", border: "1px solid #e5e7eb" }}
            >
              <div style={{ padding: "1.5rem" }}>
                <h5 className="mb-4 fw-bold" style={{ fontSize: "20px" }}>
                  Create Notification Rule
                </h5>

                <div className="mb-3">
                  <div className="form-group">
                    <input
                      type="text"
                      placeholder="Notification Name"
                      value={title}
                      onChange={(e) => setTitle(e.target.value)}
                    />
                  </div>
                </div>

                <div className="mb-3">
                  <div className="form-group">
                    <select onChange={onchanges}>
                      <option disabled selected value="">
                        Notification Redirect
                      </option>
                      {filterdata?.map((item, index) => (
                        <option key={index} value={item}>
                          {item}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>

                <div className="mb-3">
                  <div className="form-group">
                    <select
                      value={audience}
                      onChange={(e) => setAudience(e.target.value)}
                    >
                      <option value="All">All</option>
                      <option value="User">All Users</option>
                      <option value="Astrologer">All Astrologers</option>
                    </select>
                  </div>
                </div>

                {(audience === "Astrologer" || audience === "User") && (
                  <div
                    className="p-3 rounded mb-3"
                    style={{
                      border: "1px solid #d1d5db",
                      backgroundColor: "#f8fafc",
                    }}
                  >
                    <h6 className="fw-semibold mb-3">Filters</h6>

                    <div className="d-flex align-items-center gap-3 mb-3">
                      <div className="form-check m-0">
                        <input
                          style={{ borderColor: "black" }}
                          className="form-check-input"
                          type="checkbox"
                          id="beforeSendDaysCheckbox"
                          checked={beforeSendDays}
                          onChange={(e) => setBeforeSendDays(e.target.checked)}
                        />
                        <label
                          className="form-check-label ms-2"
                          htmlFor="beforeSendDaysCheckbox"
                        >
                          BeforeSendDays
                        </label>
                      </div>

                      <input
                        type="number"
                        disabled={!beforeSendDays}
                        style={{ width: "200px", borderColor: "#fdb774" }}
                        className="form-control"
                        placeholder="Number of sending days"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                      />
                    </div>

                    {filters?.map((filter, i) => (
                      <div
                        key={i}
                        className="d-flex align-items-center gap-2 mb-2 flex-wrap"
                      >
                        {i !== 0 && (
                          <div>
                            <select
                              className="form-select"
                              value={filter.logic}
                              onChange={(e) =>
                                handleFilterChange(i, "logic", e.target.value)
                              }
                            >
                              <option value="AND">AND</option>
                              <option value="OR">OR</option>
                            </select>
                          </div>
                        )}

                        <div className="d-flex gap-2">
                          <select
                            className="form-select no-focus:focus "
                            style={{ borderColor: "#fdb774" }}
                            value={filter.columnType}
                            onChange={(e) =>
                              handleFilterChange(
                                i,
                                "columnType",
                                e.target.value
                              )
                            }
                          >
                            <option value="">Select Column Type</option>
                            <option value="DateDiffDays">DateDiffDays</option>
                            <option value="NormalDate">NormalDate</option>
                            <option value="string">String</option>
                          </select>

                          <select
                            className="form-select no-focus:focus"
                            style={{ borderColor: "#fdb774" }}
                            value={filter.field}
                            onChange={(e) =>
                              handleFilterChange(i, "field", e.target.value)
                            }
                          >
                            <option value="">Select Field</option>
                            {fieldOptions?.map((item, index) => (
                              <option key={index} value={item.ColumnName}>
                                {item.DisplayName}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div>
                          <select
                            className="form-select no-focus:focus"
                            style={{ borderColor: "#fdb774" }}
                            value={filter.operator}
                            onChange={(e) =>
                              handleFilterChange(i, "operator", e.target.value)
                            }
                          >
                            <option value="=">Equals</option>
                            <option value="!=">Not Equals</option>
                            <option value=">">Greater Than</option>
                            <option value="<">Less Than</option>
                          </select>
                        </div>

                        <div>
                          {filter.columnType == "NormalDate" ? (
                            <DatePicker
                              selected={
                                filter.value ? new Date(filter.value) : null
                              }
                              onChange={(date) => {
                                const formattedDate = date
                                  ? format(date, "yyyy-MM-dd")
                                  : "";
                                handleFilterChange(i, "value", formattedDate);
                              }}
                              placeholderText="Select Date"
                              className="form-control"
                              style={{ borderColor: "#fdb774" }}
                            />
                          ) : (
                            <input
                              type="text"
                              className="form-control"
                              placeholder="Value"
                              style={{ borderColor: "#fdb774" }}
                              value={filter.value}
                              onChange={(e) =>
                                handleFilterChange(i, "value", e.target.value)
                              }
                            />
                          )}
                        </div>

                        <div>
                          <button
                            className="btn btn-outline-danger btn-sm"
                            onClick={() => deleteFilter(i)}
                          >
                            &times;
                          </button>
                        </div>
                      </div>
                    ))}

                    <div className="mt-3">
                      <button
                        className="btn btn-outline-success btn-sm"
                        onClick={addFilter}
                      >
                        + Add Filter
                      </button>
                    </div>
                  </div>
                )}

                <div style={{ textAlign: "center", color: "black" }}> OR</div>
                <div className="mb-3">
                  <textarea
                    className="form-control"
                    style={{ borderColor: "#fdb774" }}
                    placeholder="Custom Query"
                    value={customnotification}
                    onChange={(e) => setCustomnotification(e.target.value)}
                    rows={4}
                  />
                </div>

                <div className="d-flex justify-content-end mt-2">
                  <button
                    className="btn me-2"
                    style={{
                      backgroundColor: "#ff6f00",
                      color: "#fff",
                      fontWeight: 600,
                      width: "150px",
                    }}
                    onClick={handleSubmit}
                  >
                    Save
                  </button>

                  <button
                    className="btn"
                    style={{
                      backgroundColor: "red",
                      color: "#fff",
                      fontWeight: 600,
                      width: "150px",
                    }}
                    onClick={() => setPostModel(false)}
                  >
                    Close
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>

        <Modal
          className="modal fade "
          size="2xl"
          show={editModel}
          onHide={() => setEditModel(false)}
          backdrop="static"
        >
          <form>
            <div className="modal-header">
              <h4 className="modal-title fs-20">Update Notification</h4>
              <button
                type="button"
                className="btn-close"
                onClick={() => setEditModel(false)}
                data-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body p-3">
              <i className="flaticon-cancel-12 close" data-dismiss="modal"></i>
              <div className="row card flex-row p-2 pb-2">
                <div className="d-flex g-3 align-items-center p-3 col-12 ml-4">
                  <div className="col-3">
                    <button
                      className="btn btn-primary py-2"
                      type="button"
                      disabled={autoManual}
                      style={{ marginLeft: "20px", width: "100%" }}
                      onClick={() => {
                        AddObj();
                      }}
                      name="AddButton"
                    >
                      Add
                    </button>
                  </div>

                  <div className="col-3 d-flex justify-content-center align-items-center">
                    <div class="form-check">
                      <input
                        type={"checkbox"}
                        style={{ marginRight: "px" }}
                        name={"Manual"}
                        value={autoManual}
                        disabled
                        onChange={(e) => {
                          setautoManual(!autoManual);
                          setQuerryText("");
                        }}
                        className="form-check-input"
                      />
                      <label class="form-check-label" for="Manual">
                        Manual
                      </label>
                    </div>
                  </div>
                </div>
                <div className=" col-6 ">
                  <label for="NotificationName" className="form-label">
                    Notification Rule Name
                  </label>
                  <input
                    style={{ height: "30px", width: "30vw" }}
                    type="text"
                    className="form-control col-6"
                    placeholder="Notification Rule name"
                    onChange={(e) => setRulename(e.target.value)}
                    aria-label="NotificationName"
                    value={rulename}
                  />
                </div>
                ,
                <div
                  className="row mt-4"
                  style={{ maxHeight: "300px", overflowY: "auto" }}
                >
                  {ArrObj?.map((field, index) => (
                    <div key={field.name} className="col-md-12 mb-3">
                      <div className="p-3 border rounded shadow-sm ">
                        <div className="row align-content-center align-items-center">
                          <div className="col-md-1">
                            <label className="form-label fw-bold">
                              {field.label}
                            </label>
                          </div>

                          <div className="col-md-2">
                            <select
                              name={field.name}
                              onChange={(e) => handleRowChange(e, field, index)}
                              className="form-select"
                            >
                              <option value="">Select {field.label}</option>
                              {["ID", "Name", "Title", "Location", "Dob"]?.map(
                                (option, i) => (
                                  <option key={i} value={option}>
                                    {option}
                                  </option>
                                )
                              )}
                            </select>
                          </div>

                          <div className="col-md-2">
                            <select
                              name={`${field.name}_operator`}
                              onChange={(e) =>
                                handle_OperatorChange(e, field, index)
                              }
                              className="form-select"
                            >
                              <option value="">Select Operator</option>
                              {[
                                "Equal",
                                "Not Equal",
                                "Start With",
                                "Ends With",
                                "Contain",
                                "In",
                                "Is Null",
                                "Is Not Null",
                                "Between",
                              ]?.map((option, i) => (
                                <option key={i} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="col-md-2">
                            {field.operator === "Between" &&
                            field.type === "Number" ? (
                              <input
                                type="range"
                                name={field.name}
                                value={field.value}
                                min="0"
                                max="50"
                                onChange={(e) => handleChange(e, field, index)}
                                className="form-range"
                              />
                            ) : (
                              <input
                                type={
                                  field.type === "Number" ? "number" : "text"
                                }
                                name={field.name}
                                value={field.value}
                                onChange={(e) => handleChange(e, field, index)}
                                className="form-control"
                                placeholder={`Enter ${field.label?.toLowerCase()}`}
                              />
                            )}
                          </div>

                          <div className="col-md-2">
                            <select
                              name={`${field.name}_operator`}
                             
                              className="form-select"
                            >
                              <option value="">Select option</option>
                              {["And"]?.map((option, i) => (
                                <option key={i} value={option}>
                                  {option}
                                </option>
                              ))}
                            </select>
                          </div>

                          <div className="col-1">
                            <div
                              style={{
                                border: "1px solid black",
                                borderRadius: "50%",
                                padding: "1px",
                                width: "25px",
                                height: "25px",
                                lineHeight: "1",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                cursor: "pointer",
                              }}
                              onClick={() => handleDeleteRow(index)}
                            >
                              <RxCross2 fontSize={20} />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="row">
                  <div className="mb-3 col-6">
                    <label
                      for="exampleFormControlTextarea1"
                      className="form-label"
                    >
                      Example textarea
                    </label>
                    <textarea
                      value={querryText}
                      onChange={(e) => setQuerryText(e.target.value)}
                      class="form-control"
                      id="exampleFormControlTextarea1"
                      rows="3"
                    ></textarea>
                  </div>
                </div>
                <div className="row justify-content-end">
                  <div className="col-2">
                    <button
                      type="button"
                      className="btn btn-success"
                      style={{ width: "150px" }}
                      onClick={() => {
                        UpdeteClick();
                      }}
                    >
                      Update
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer">
             
              <button
                type="button"
                onClick={() => {
                  setEditModel(false);
                  // Reset();
                }}
                className="btn btn-danger"
              >
                <i className="flaticon-delete-1"></i> Close
              </button>
            </div>
          </form>
        </Modal>
      </div>
    </div>
  );
};

export default NotificationRule;
